import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import * as SurveyAPI from "../../services/surveyService";

export function useSurveyStatus() {
  const { i18n } = useTranslation("common");
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const locale = (i18n.language || "en").slice(0, 2);

  const refresh = async () => {
    try {
      setLoading(true);
      const data = await SurveyAPI.fetchMyStatus(locale);
      setStatus(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, [locale]);

  return { status, loading, error, refresh };
}
